import { render, staticRenderFns } from "./PlayerRegistrationFormFansAndFollowersCard.vue?vue&type=template&id=1f778107&scoped=true&"
import script from "./PlayerRegistrationFormFansAndFollowersCard.vue?vue&type=script&lang=js&"
export * from "./PlayerRegistrationFormFansAndFollowersCard.vue?vue&type=script&lang=js&"
import style0 from "./PlayerRegistrationFormFansAndFollowersCard.vue?vue&type=style&index=0&id=1f778107&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f778107",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
